import { Auditable, QueryParams, SortParams } from "..";

export interface PersonType extends Auditable {
    id: number;
    name: string;
    tenantId: number;
}

export const DefaultPersonTypeQueryParams: QueryParams = {
    name: "",
};

export const DefaultPersonTypeSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
